import branchReducer from './branchSlice';
import * as branchActions from './actions';
import * as branchSelector from './selector';

export {
  branchActions,
  branchSelector
}

export default branchReducer